module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Strengelbach-de23755d8876155fb4918b09f07c72fc.svg";